const RELATIVE = new Intl.RelativeTimeFormat("ja", { numeric: "auto" });
const ABSOLUTE = new Intl.DateTimeFormat("ja-JP", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
});

const UNITS: [Intl.RelativeTimeFormatUnit, number][] = [
  ["second", 60],
  ["minute", 60],
  ["hour", 24],
  ["day", 7],
  ["week", 4.348],
  ["month", 12],
];

/** 「3 分前」形式。1 年以上前は年で丸める。 */
export function relativeTime(iso: string): string {
  const diffMs = new Date(iso).getTime() - Date.now();
  let value = diffMs / 1000;
  for (const [unit, span] of UNITS) {
    if (Math.abs(value) < span) return RELATIVE.format(Math.round(value), unit);
    value /= span;
  }
  return RELATIVE.format(Math.round(value), "year");
}

export function absoluteTime(iso: string): string {
  return ABSOLUTE.format(new Date(iso));
}
